import React, { useState } from 'react';
import { MapPin, Heart, Image as ImageIcon } from 'lucide-react';

const DestinationCard = ({ destination, imageBaseUrl, isWishlisted, onExplore, onWishlist }) => {
  const [imgError, setImgError] = useState(false);

  const rawPath =
    destination.image ||
    destination.jjdestinationgallerys?.[0]?.des_gallery ||
    null;

  const imgUrl = rawPath ? `${imageBaseUrl}/${rawPath}` : null;
  const showPlaceholder = !imgUrl || imgError;

  return (
    <div className="pub-cus-des-destination-card">

      <div className="pub-cus-des-card-img-wrap">
        {!showPlaceholder ? (
          <img
            src={imgUrl}
            alt={destination.destination_name}
            className="pub-cus-des-card-img"
            loading="lazy"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="pub-cus-des-card-img-placeholder">
            <ImageIcon size={32} />
          </div>
        )}
        <div className="pub-cus-des-card-gradient" />

        {destination.best_season && (
          <span className="pub-cus-des-card-season-pill">
            {destination.best_season}
          </span>
        )}

        <span className="pub-cus-des-card-province-pill">
          <MapPin size={12} />
          {destination.province}
        </span>
      </div>

      <div className="pub-cus-des-card-body">
        <h3 className="pub-cus-des-card-title">{destination.destination_name}</h3>

        {destination.description && (
          <p className="pub-cus-des-card-desc">{destination.description}</p>
        )}

        {destination.district && (
          <div className="pub-cus-des-card-cats mb-3">
            <span className="pub-cus-des-card-cat-tag">{destination.district}</span>
            {destination.climate && (
              <span className="pub-cus-des-card-cat-tag">{destination.climate}</span>
            )}
          </div>
        )}

        <div className="pub-cus-des-card-actions">
          <button
            className="pub-cus-des-card-explore-btn"
            onClick={onExplore}
          >
            Explore Destination
          </button>

        
        </div>
      </div>
    </div>
  );
};

export default DestinationCard;